/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The value of assigned role.

Values: 0=OnlyOwner, 1=OwnerAndManagers, 2=Everyone, 3=Hidden, 4=Mixed, 5=UserSpecific
 * @export
 * @enum {number}
 */

export enum AssignedTo {
    OnlyOwner = 0,
    OwnerAndManagers = 1,
    Everyone = 2,
    Hidden = 3,
    Mixed = 4,
    UserSpecific = 5
}


